"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VizClientFieldCard = void 0;
const tslib_1 = require("tslib");
const data_structures_1 = require("@tableau/data-structures");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const catalog_core_1 = require("@tableau/catalog-core");
const catalog_messages_1 = require("@tableau/catalog-messages");
const FieldFunctions_1 = require("../field/functions/FieldFunctions");
const FieldNameMapping_1 = require("../field/functions/FieldNameMapping");
const FieldPropertyComponents_1 = require("../FieldDetails/FieldPropertyComponents");
const FieldsReferencedByFieldQueryGrid_1 = require("../FieldDetails/FieldsReferencedByFieldQueryGrid");
const LinksDisplayGrid_1 = require("../sharedDisplayGrid/LinksDisplayGrid");
const CalculationDetails_1 = require("./CalculationDetails");
const VizClientFieldCardDescription_1 = require("./VizClientFieldCardDescription");
const VizClientFieldCardStyles_1 = require("./VizClientFieldCardStyles");
class VizClientFieldCard extends react_1.default.Component {
    renderHeader() {
        const fieldIcon = (0, FieldFunctions_1.iconForField)(this.props.field);
        return (react_1.default.createElement(VizClientFieldCardStyles_1.FieldCardHeaderWrapper, { "data-tb-test-id": 'data-details-field-card-header-test-id' }, fieldIcon
            ? (react_1.default.createElement(VizClientFieldCardStyles_1.FieldCardHeaderFieldType, null, FieldNameMapping_1.FieldNameMappings[fieldIcon]()))
            : null));
    }
    // TODO: use renderFieldsReferencedByField for BinFields when no router issue has been fixed see TFSID: 1021036
    renderFieldsReferencedByField(field, title) {
        var _a, _b;
        const count = (_b = (_a = field.fieldsConnection) === null || _a === void 0 ? void 0 : _a.totalCount) !== null && _b !== void 0 ? _b : null;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(VizClientFieldCardStyles_1.FieldCardDetailTitleWrapper, null,
                react_1.default.createElement(VizClientFieldCardStyles_1.FieldCardDetailTitle, null, title)),
            react_1.default.createElement(VizClientFieldCardStyles_1.FieldsReferencingFieldsWrapper, { style: { height: (0, LinksDisplayGrid_1.getRowHeight)(count, FieldPropertyComponents_1.fieldsWrapperMaxRows) } },
                react_1.default.createElement(FieldsReferencedByFieldQueryGrid_1.FieldsReferencedByFieldQueryGrid, { fieldId: field.id, rowCount: count, targetBlank: true, useAnchor: true, "data-tb-test-id": 'fields-reference-by-field-query-grid' }))));
    }
    renderCalculation(field) {
        if (field && 'formula' in field) {
            return react_1.default.createElement(CalculationDetails_1.CalculationDetails, { field: field, workbookVizportalUrlId: this.props.workbookVizportalUrlId });
        }
        return null;
    }
    renderBinSize(binSize) {
        if (binSize === null) {
            return null;
        }
        return (react_1.default.createElement("div", { "data-tb-test-id": 'data-details-bin-size-test-id' },
            react_1.default.createElement(VizClientFieldCardStyles_1.FieldCardDetailTitleWrapper, null,
                react_1.default.createElement(VizClientFieldCardStyles_1.FieldCardDetailTitle, null, catalog_messages_1.Messages.FieldDetails_BinSize())),
            react_1.default.createElement(VizClientFieldCardStyles_1.FieldCardDetailText, null, binSize)));
    }
    renderFieldDetailsLink() {
        if (!this.props.workbookVizportalUrlId) {
            return null;
        }
        return (react_1.default.createElement(catalog_core_1.SiteUrlsContext.Consumer, null, urls => (react_1.default.createElement(widgets_1.TextLinkWidget, { href: urls.workbookLineageFieldUrl(this.props.workbookVizportalUrlId ? this.props.workbookVizportalUrlId : '', this.props.field.id), target: '_blank', testId: 'data-details-field-view-more-link-test-id' }, catalog_messages_1.Messages.ViewMore()))));
    }
    renderTypeSpecificFieldDetails() {
        if (this.props.field.__typename !== 'DatasourceField') {
            return this.renderTypeSpecificNonDatasourceFieldDetails(this.props.field);
        }
        else if (this.props.field.remoteField) {
            return this.renderTypeSpecificNonDatasourceFieldDetails(this.props.field.remoteField);
        }
        else {
            return null;
        }
    }
    renderTypeSpecificNonDatasourceFieldDetails(field) {
        if (!field) {
            return null;
        }
        switch (field.__typename) {
            case 'BinField':
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    this.renderBinSize(field.binSize),
                    this.renderFieldsReferencedByField(field, catalog_messages_1.Messages.ReferencedFields())));
            case 'CalculatedField':
                return (react_1.default.createElement(react_1.default.Fragment, null, this.renderCalculation(field)));
            case 'GroupField':
                return (react_1.default.createElement(react_1.default.Fragment, null, this.renderFieldsReferencedByField(field, catalog_messages_1.Messages.GroupedFields())));
            case 'CombinedField':
            case 'CombinedSetField':
                return (react_1.default.createElement(react_1.default.Fragment, null, this.renderFieldsReferencedByField(field, catalog_messages_1.Messages.CombinedFields())));
            case 'HierarchyField':
            case 'SetField':
                return (react_1.default.createElement(react_1.default.Fragment, null, this.renderFieldsReferencedByField(field, catalog_messages_1.Messages.ReferencedFields())));
            case 'ColumnField':
            case 'DatasourceField':
                return null;
            default:
                (0, data_structures_1.assertNever)(field);
                return null;
        }
    }
    render() {
        return (react_1.default.createElement(VizClientFieldCardStyles_1.FieldCard, { "data-tb-test-id": 'data-details-field-card-test-id' },
            react_1.default.createElement(VizClientFieldCardStyles_1.FieldCardWrapper, null,
                this.renderHeader(),
                react_1.default.createElement(VizClientFieldCardStyles_1.FieldCardDetailsWrapper, null,
                    react_1.default.createElement(VizClientFieldCardDescription_1.VizClientFieldCardDescription, { field: this.props.field }),
                    this.renderTypeSpecificFieldDetails(),
                    this.renderFieldDetailsLink()))));
    }
}
exports.VizClientFieldCard = VizClientFieldCard;
//# sourceMappingURL=VizClientFieldCard.js.map